module.exports = __webpack_public_path__ + "img/edit.743c9971.svg";